import { render, staticRenderFns } from "./Suggestions.vue?vue&type=template&id=32d0f085&"
import script from "./Suggestions.vue?vue&type=script&lang=js&"
export * from "./Suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports